import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { privatePackageTrackerModel } from 'app.models';
import { locationModel } from 'app/app.models';
import MainView from 'shared/main-view/main-view.component';
import callMutation from 'shared/relay/mutations/call-mutation';
import UserFeedbackAlert from 'shared/alert/user-feedback-alert/user-feedback-alert.component';
import emoji from 'images/sad.png';
import {
  CLOSE_BUTTON_VALUE,
  FEEDBACK_ALERT_ERROR_TITLE,
  RETRY_BUTTON_VALUE
} from 'tracker.constants';
import { CONFIRM_DELIVERY, CONTEST_SEND } from 'tracker.routes';
import {
  CONFIRM_DELIVERY_ERROR_DESCRIPTION,
  CONFIRM_ORIGINAL_ADDRESS_ERROR_DESCRIPTION
} from '../../../package.constants';
import { CONTESTATION_TITLE } from './start-contest.constants';
import confirmDeliveryWithoutAuthMutation from '../../confirm-delivery/confirm-delivery-without-auth.mutation';
import ConfirmDeliveryHeader from '../confirm-delivery-header.component';
import StartContestMain from './start-contest-main.component';
import StartContestButton from './start-contest-button.component';

// This component is called by new-confirm-delivery
// It is used to inform the receiver about the events that occur when a DNR is created.
export class StartContest extends Component {
  constructor(props) {
    super(props);

    const shouldConfirmPackageDelivery =
      get(
        this.props,
        'privatePackageTracker.shouldConfirmPackageDelivery',
        ''
      ) || get(this.props, 'location.state.shouldConfirmPackageDelivery', '');

    const { wasDeliveredByRecipient } = this.props;

    this.state = {
      shouldConfirmPackageDelivery,
      wasDeliveredByRecipient,
      userFeedbackAlert: false,
      userFeedbackAlertProps: {
        illustration: emoji,
        title: FEEDBACK_ALERT_ERROR_TITLE,
        description: CONFIRM_ORIGINAL_ADDRESS_ERROR_DESCRIPTION,
        buttonsProps: [{ value: RETRY_BUTTON_VALUE, onClick: () => {} }]
      },
      isConfirmDeliveryButtonsDisabled: false
    };
  }

  // Check if is the flow without Auth
  _checkUuid = () => {
    const uuid = get(this.props, 'location.state.uuid', false);
    return uuid;
  };

  // Call the New-confirm-delivery-header, passing the content title
  _renderHeader = () => {
    const headerProps = {
      onClickBack: () => this._goToPrevScreen(CONFIRM_DELIVERY),
      headerText: CONTESTATION_TITLE
    };

    return (
      <ConfirmDeliveryHeader
        onClickBack={headerProps.onClickBack}
        headerText={headerProps.headerText}
      />
    );
  };

  _goToPrevScreen = () => {
    const { history } = this.props;

    const {
      location: {
        state: {
          uuid,
          previousPage,
          receivedBy,
          recipientInfo,
          shouldConfirmPackageDelivery,
          packageStatusPath,
          packageStatusSearch
        }
      }
    } = this.props;
    return history.replace({
      pathname: `${previousPage}`,
      state: {
        receivedBy,
        recipientInfo,
        shouldConfirmPackageDelivery,
        uuid,
        packageStatusPath,
        packageStatusSearch
      }
    });
  };

  // this method is used ro redirect to other pages, passing the information
  // about privatePackageTracker, the next page will be send-contestation-message
  _goToNextScreen = nextPathname => {
    const {
      history,
      location: { pathname }
    } = this.props;

    const {
      location: {
        state: { uuid, packageStatusPath, packageStatusSearch }
      }
    } = this.props;
    return history.replace({
      pathname: `${pathname}/${nextPathname}`,
      state: {
        uuid,
        previousPage: `${pathname}`,
        packageStatusPath,
        packageStatusSearch
      }
    });
  };

  // Call mutation to update information about if the package was delivered
  // If it wasDeliveredByRecipient is false, is initiated the DNR process
  _onConfirmDeliveryMutation = ({ wasDeliveredByRecipient }) => {
    const {
      privatePackageTracker: {
        packageInfo: { packageId }
      }
    } = this.props;
    const uuid = this._checkUuid();

    const variables = {
      input: {
        pdcbrUuid: uuid,
        wasDelivered: wasDeliveredByRecipient
      }
    };

    const callbacks = {
      onSuccess: response => {
        const responseWithoutAuth =
          response.packageTrackerDeliveryConfirmationByRecipientWithoutAuth;

        this._onSuccessConfirmDeliveryMutation(
          responseWithoutAuth,
          wasDeliveredByRecipient
        );
      },
      onFailure: this._onFailureConfirmDeliveryMutation
    };

    return callMutation(
      confirmDeliveryWithoutAuthMutation,
      variables,
      callbacks
    );
  };

  // Handle to the button of begin constestation
  _onClickToDenyDelivery = () => {
    this.setState({ isConfirmDeliveryButtonsDisabled: true });
    this._onConfirmDeliveryMutation({ wasDeliveredByRecipient: false });
  };

  // Handle of the button to close alert in case of mutation failure
  _onClickToCloseAlert = () => {
    this.setState({ userFeedbackAlert: false });
  };

  // Show alert in case of mutation failure
  _onFailureConfirmDeliveryMutation = () => {
    return this.setState({
      isConfirmDeliveryButtonsDisabled: false,
      userFeedbackAlert: true,
      userFeedbackAlertProps: {
        illustration: emoji,
        title: FEEDBACK_ALERT_ERROR_TITLE,
        description: CONFIRM_DELIVERY_ERROR_DESCRIPTION,
        buttonsProps: [
          {
            value: CLOSE_BUTTON_VALUE,
            onClick: this._onClickToCloseAlert
          }
        ]
      }
    });
  };

  // Redirect to send-contestation-message page, in case of mutation sucess
  _onSuccessConfirmDeliveryMutation({ success }, wasDeliveredByRecipient) {
    if (!success) {
      return this._onFailureConfirmDeliveryMutation();
    }

    this.setState({ wasDeliveredByRecipient });
    return this._goToNextScreen(CONTEST_SEND);
  }

  render() {
    const {
      userFeedbackAlert,
      userFeedbackAlertProps,
      shouldConfirmPackageDelivery,
      wasDeliveredByRecipient,
      isConfirmDeliveryButtonsDisabled
    } = this.state;
    const { isChecked, history } = this.props;
    let receivedByName = get(
      this.props,
      'privatePackageTracker.receivedBy',
      ''
    );

    let statusPath = '';
    const {
      location: {
        state: { receivedBy, packageStatusPath, packageStatusSearch }
      }
    } = this.props;

    receivedByName = receivedBy;
    statusPath = `${packageStatusPath}${packageStatusSearch}`;

    return (
      <MainView className="tracker-content classificationMainView">
        {/* Header with backbutton and title */}
        {this._renderHeader()}
        <StartContestMain receivedBy={receivedByName} />

        {/* Only render the checkbox and button if the receiver 
        is able do answer (24h after delivered and in the max one week later),
        and the question was not answered yet.
        wasDelivereeByRecipient is a case of the three outputs of a boolean
        true: if the receiver have already confirmed the delivery
        false: if the receiver have already denied the delivery
        null: if the question was not answered yet
        this code was firstly used in main-package-info-card
        */}
        {shouldConfirmPackageDelivery && wasDeliveredByRecipient === null && (
          <StartContestButton
            onClickToAccept={this._onClickToDenyDelivery}
            isChecked={isChecked}
            isDisabled={isConfirmDeliveryButtonsDisabled}
            statusPath={statusPath}
            history={history}
          />
        )}
        {userFeedbackAlert && (
          <UserFeedbackAlert
            illustration={userFeedbackAlertProps.illustration}
            title={userFeedbackAlertProps.title}
            description={userFeedbackAlertProps.description}
            buttonsProps={userFeedbackAlertProps.buttonsProps}
          />
        )}
      </MainView>
    );
  }
}

StartContest.displayName = 'StartContest';

StartContest.propTypes = {
  privatePackageTracker: PropTypes.shape(privatePackageTrackerModel),
  actions: PropTypes.shape({
    savePrivatePackageTracker: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape(locationModel).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired
  }).isRequired,
  wasDeliveredByRecipient: PropTypes.bool,
  isChecked: PropTypes.bool
};

StartContest.defaultProps = {
  wasDeliveredByRecipient: null,
  isChecked: false,
  privatePackageTracker: { packageInfo: { packageId: null } }
};

export default connect()(StartContest);
